var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketActive = function SvgMarketActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M1.5 16.25h15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.75 10.25h1.5c.207 0 .375.168.375.375v5.063a.375.375 0 0 1-.375.374h-1.5a.375.375 0 0 1-.375-.375v-5.062c0-.207.168-.375.375-.375Zm4.5-7.5h1.5c.207 0 .375.168.375.375v12.563a.375.375 0 0 1-.375.374h-1.5a.375.375 0 0 1-.375-.375V3.126c0-.207.168-.375.375-.375Zm4.5 3.75h1.5c.207 0 .375.168.375.375v8.813a.375.375 0 0 1-.375.374h-1.5a.375.375 0 0 1-.375-.375V6.876c0-.207.168-.375.375-.375Z"
  })));
};
export default SvgMarketActive;